import React from 'react';
import { FormattedMessage, injectIntl, } from 'react-intl';
import { listCalendarWeeks } from 'helpers/calendarUtils';
import { CopyToWeekCall } from 'helpers/api-calls/schedule-calls';
import { CreateDemoDataCall, DeleteDemoDataCall } from 'helpers/api-calls/demo-calls';
import { generatePlannedShifts, getJobStatus } from 'helpers/api-calls/schedule-generation-calls';

import WeekPickerComponent from 'components/CalendarComponents/WeekPickerComponent/WeekPickerComponent';
import './ScheduleHeaderComponent.scss';
import {Mixpanel} from 'helpers/Mixpanel';

import PublishScheduleComponent from './PublishScheduleComponent';
import ContactSalesModal from './ContactSalesModal';
import CopyToWeekComponent from "./CopyToWeekComponent";

import SearchFilterComponent from './ScheduleSearchFilterComponent';

import Modal from 'components/GeneralComponents/Modal';
import styledConfirm from '../../../Requests/components/styled';

import Spinner from 'react-bootstrap/Spinner';
import BooModal from 'react-bootstrap/Modal';

import moment from 'moment';
import utils from 'pages/ScheduleCalendar/duck/utils';
import draftLogic from 'pages/ScheduleCalendar/duck/draftLogic';

import { startOfLocationFiscalWeek, endOfLocationFiscalWeek } from '../../../../helpers/date-time';

import { CSVLink } from "react-csv";

import ScheduleGenerationConfigModal from './ScheduleGenerationConfigModal';
import ScheduleGenerationConfirmModal from './ScheduleGenerationConfirmModal';
import { showSuccessMessage, buildApiConfig, formatHoursOfOperationSummary } from './schedule-generation-utils';

const GearIcon = () => (
  <svg
    viewBox="0 0 16 16"
    width="14"
    height="14"
    fill="currentColor"
  >
    <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z"/>
    <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115l.094-.319z"/>
  </svg>
);

class ScheduleHeaderComponent extends React.PureComponent {

  // use class properties, not trigger re-render
  scrWeekDay = null;
  destWeekDay = null;
  ownerIds = null;

  constructor(props) {
    super(props);

    this.state = {
      showingPublishScheduleModal: false,
      showingContactSalesModal: false,
      showCopyToWeekModal: false,
      showLoading: false,
      showExportSelectionMenu: false,
      showFinishPastingSnackBar: false,
      showGenerationConfigModal: false,
      showConfirmModal: false,
      generationConfig: null,
      isGenerating: false,
      generationError: null
    };

  }

  componentDidMount() {
  }

  moveCurrentWeekBackward = () => {
    const { changeDateRangeSlice, rangeStart, rangeEnd } = this.props;

    const newDateRangeStart = utils.previousWeek(rangeStart);
    const newDateRangeEnd = utils.previousWeek(rangeEnd);

    changeDateRangeSlice(newDateRangeStart, newDateRangeEnd);
    Mixpanel.track('Previous week', { 'target_week': newDateRangeStart.format("MMM Do YYYY") + ' - ' + newDateRangeEnd.format("MMM Do YYYY") });
  };

  moveCurrentWeekForward = () => {
    const { changeDateRangeSlice, rangeStart, rangeEnd } = this.props;

    const newDateRangeStart = utils.nextWeek(rangeStart);
    const newDateRangeEnd = utils.nextWeek(rangeEnd);

    changeDateRangeSlice(newDateRangeStart, newDateRangeEnd);
    Mixpanel.track('Next week', { 'target_week': newDateRangeStart.format("MMM Do YYYY") + ' - ' + newDateRangeEnd.format("MMM Do YYYY") });
  };

  moveCurrentWeekTo = (sDate) => {
    const { changeDateRangeSlice } = this.props;

    const newDateRangeStart = moment(sDate);
    const newDateRangeEnd = newDateRangeStart.clone().add(7, 'day').subtract(1, 'second');

    changeDateRangeSlice(newDateRangeStart, newDateRangeEnd);
    this.handleFinishPasting();
  }

  moveToToday = () => {
    const { locationData } = this.props;

    var start = startOfLocationFiscalWeek(locationData.fiscal_day);
    this.moveCurrentWeekTo(start);

    Mixpanel.track('Go to today');
  }

  handlePublishClick = () => {
    const { locationData, shifts, shouldShowOpenShiftUI } = this.props;
    const hasPublishAccess = locationData?.admin_dashboard_access;

    // Gate: enterprise location without publish access AND batch contains AI-generated shifts
    // If admin_dashboard_access is undefined/null (API not updated yet), allow publish (safe fallback)
    if (hasPublishAccess === false) {
      const unpublishedShifts = draftLogic.draftShiftsToPublish(shifts, shouldShowOpenShiftUI);
      const hasGeneratedShifts = unpublishedShifts.some(shift =>
        shift.global_identifier && shift.global_identifier.startsWith('gen_')
      );

      if (hasGeneratedShifts) {
        this.setState({ showingContactSalesModal: true });
        return;
      }
    }

    this.setState({ showingPublishScheduleModal: true });
  }

  closePublishScheduleModel = () => {
    this.setState({ showingPublishScheduleModal: false });
  }

  closeContactSalesModal = () => {
    this.setState({ showingContactSalesModal: false });
  }

  handleCopyToWeekSelect = (event, destWeekDay) => {
    this.destWeekLabel = event.target.textContent;
    this.destWeekDay = destWeekDay;
    this.scrWeekDay = this.props.startStr;

    this.setState({ showCopyToWeekModal: true });
  }

  closeCopyToWeekModal = () => {
    this.setState({ showCopyToWeekModal: false });
  }

  copyToWeekDispatch = (locationId, scrWeekDay, destWeekDay, ownerIds, includeOpenShifts, includeVto) => {
    this.setState({ showLoading: true });
    return CopyToWeekCall(this.props.locationId, this.scrWeekDay, this.destWeekDay, this.ownerIds, includeOpenShifts, includeVto).then(({ data }) => {
      // TODO: switch week
      this.moveCurrentWeekTo(this.destWeekDay)
    }).catch((error) => {
      Mixpanel.error('Copy To Week', { 'error': error });
    }).finally(() => {
      // Code to run regardless of success or failure
      this.setState({ showLoading: false });
    });
  }

  handleExportClick = () => {
    const { showExportSelectionMenu } = this.state;
    if (showExportSelectionMenu == true) {
      this.setState({ showExportSelectionMenu: false });
    } else {
      this.setState({ showExportSelectionMenu: true });
    }
  }

  handleFinishPasting = () => {
    const { notifyHeaderOfShiftPasting } = this.props;
    notifyHeaderOfShiftPasting(false, null);
  }

  createFileName = (rangeStart, rangeEnd) => {
    const shiftFormat = 'YYYY-MM-DD';
    var fileName = `schedule.csv`;
    if (rangeStart != null) {
      fileName = `${rangeStart.format(shiftFormat)}_${rangeEnd.format(shiftFormat)}`;
    }
    return fileName;
  }

  handleDeleteAllSchedule = () => {
    const { handleDeleteAllSchedule } = this.props;
    handleDeleteAllSchedule();
  }

  handleDeleteUnpublishedDrafts = () => {
    const { handleDeleteUnpublishedDrafts } = this.props;
    handleDeleteUnpublishedDrafts();
  }

  handleGenerateScheduleClick = () => {
    const savedConfig = sessionStorage.getItem('scheduleGeneratorConfig');
    if (savedConfig) {
      const config = JSON.parse(savedConfig);
      const formattedConfig = {
        startDate: config.startDate,
        endDate: config.endDate,
        minShiftLength: config.minShiftLength,
        maxShiftLength: config.maxShiftLength,
        minScheduleHoursPerWeek: config.minScheduleHoursPerWeek,
        overtimeThreshold: config.overtimeThreshold,
        minBreakTime: config.minBreakTime,
        availabilityFulfillLevel: config.availabilityFulfillLevel,
        useOpenShifts: config.useOpenShifts,
        hoursOfOperation: config.hoursOfOperation
      };
      this.setState({
        showConfirmModal: true,
        generationConfig: formattedConfig
      });
    } else {
      this.setState({ showGenerationConfigModal: true });
    }
  };

  handleGenerationConfigClick = () => {
    this.setState({ showGenerationConfigModal: true });
  };

  closeGenerationConfigModal = () => {
    this.setState({ showGenerationConfigModal: false });
  };

  handleConfirmGenerate = () => {
    this.setState({ isGenerating: true, error: null });

    const savedConfig = sessionStorage.getItem('scheduleGeneratorConfig');
    if (!savedConfig) {
      this.setState({
        error: 'Configuration not found. Please try again.',
        isGenerating: false
      });
      return;
    }

    const config = JSON.parse(savedConfig);
    const apiConfig = buildApiConfig(config);

    generatePlannedShifts(apiConfig)
      .then(response => {
        // Async mode: backend returns { uuid } immediately
        const uuid = response.data?.uuid;
        if (uuid) {
          this._pollJobStatus(uuid);
        } else {
          // Fallback: sync response (e.g. if backend doesn't support async)
          this._onGenerationComplete();
        }
      })
      .catch(error => {
        console.error('Error generating schedule:', error);
        let errorMessage = 'Failed to generate schedule. Please try again.';

        if (error.response) {
          errorMessage = error.response.data?.message || errorMessage;
        } else if (error.request) {
          errorMessage = 'No response from server. Please check your connection.';
        }

        this.setState({
          error: errorMessage,
          isGenerating: false
        });
      });
  };

  _pollJobStatus = (uuid) => {
    const DONE_STATUSES = ['succeeded', 'failed', 'existing'];

    this._jobPollInterval = setInterval(() => {
      getJobStatus(uuid)
        .then(response => {
          const job = response.data?.action_job || response.data;
          if (job && DONE_STATUSES.includes(job.status)) {
            clearInterval(this._jobPollInterval);
            this._jobPollInterval = null;
            this._onGenerationComplete();
          }
        })
        .catch(err => {
          // 404 means the job record was deleted after completion — treat as success
          if (err.response && err.response.status === 404) {
            clearInterval(this._jobPollInterval);
            this._jobPollInterval = null;
            this._onGenerationComplete();
            return;
          }
          console.error('Error polling job status:', err);
        });
    }, 3000);
  };

  _onGenerationComplete = () => {
    this.setState({ showConfirmModal: false, isGenerating: false });

    showSuccessMessage();

    const { rangeStart, rangeEnd } = this.props;
    if (rangeStart && rangeEnd) {
      this.props.changeDateRangeSlice(rangeStart, rangeEnd);
      this.props.getShiftsInDateRange(rangeStart, rangeEnd, 1, 2000, true);
    }
  };

  handleCancelGenerate = () => {
    // Clean up any active polling
    if (this._jobPollInterval) {
      clearInterval(this._jobPollInterval);
      this._jobPollInterval = null;
    }
    this.setState({ showConfirmModal: false, isGenerating: false });
  };

  // --- Demo Data Handlers (added for demo_users merge) ---
  handleCreateDemoData = () => {
    const { locationId } = this.props;
    this.setState({ showLoading: true });
    CreateDemoDataCall(locationId)
      .then(() => {
        if (window.Mixpanel) window.Mixpanel.track('Create Demo Data', { locationId });
        window.location.reload(); // Refresh after create
      })
      .catch((error) => {
        if (window.Mixpanel) window.Mixpanel.error('Create Demo Data', { error });
      })
      .finally(() => {
        this.setState({ showLoading: false });
      });
  }

  handleDeleteDemoData = () => {
    const { locationId } = this.props;
    this.setState({ showLoading: true });
    DeleteDemoDataCall(locationId)
      .then(() => {
        if (window.Mixpanel) window.Mixpanel.track('Delete Demo Data', { locationId });
        window.location.reload(); // Refresh after delete
      })
      .catch((error) => {
        if (window.Mixpanel) window.Mixpanel.error('Delete Demo Data', { error });
      })
      .finally(() => {
        this.setState({ showLoading: false });
      });
  }

  render() {
    const {
      isPublishing,
      shouldShowOpenShiftUI,
      shouldShowVTOUI,
      scheduledResult,
      openShiftResult,
      vtoResult,
      scheduledUserCount,
      handleDeleteDraftsModal,
      handleDeleteEntireScheduleModal,
      allUsers,
      allUnregisteredUsers,
      publishDraftShiftsDispatch,
      shifts,
      shiftBeingPasted,
      isShowingPastingSnackBar,
      notifySearchTermChanged,
      handleDepartmentSelect,
      handleGroupSelect,
      handleSkillSelect,
      rangeStart,
      rangeEnd,
      notifyTeamOfPublishDispatch,
      locationSettings,
      locationData,
      locationId,
      startStr,
      exportableData,
      tableFormatData,
      searchTerm,
      departments,
      channels,
      skills
    } = this.props;
    let {
      showingPublishScheduleModal,
      showingContactSalesModal,
      showCopyToWeekModal,
      showLoading,
      flickerWeekPicker,
      showGenerationConfigModal,
      showConfirmModal,
      generationConfig,
      isGenerating,
      showExportSelectionMenu
    } = this.state;

    const format = 'MMM DD';

    const copyToWeekText = <FormattedMessage id="Scheduling.copyToWeek" defaultMessage='Copy to Week' />;
    const toolsText = <FormattedMessage id="Scheduling.tools" defaultMessage='Tools' />;

    const exportToCSVText = <FormattedMessage id="Scheduling.exportToCSV" defaultMessage='Export Schedule Format' />;
    const exportToPdfText = <FormattedMessage id="Scheduling.exportToPDF" defaultMessage='Export Importer Format' />;
    const deleteUnpublishedChangesText = <FormattedMessage id="Scheduling.deleteUnpublishedChanges" defaultMessage='Delete unpublished shifts' />;
    const deleteEntireScheduleText = <FormattedMessage id="Scheduling.deleteEntireSchedule" defaultMessage='Delete entire schedule' />;

    var message = null;
    if (rangeStart && rangeEnd && locationData) {
      message = locationData.location_name + ' (' + locationData.swift_code + ') schedule updated: ' + rangeStart.format(format) + ' - ' + rangeEnd.format(format);
    }

    let weeks_list = listCalendarWeeks(undefined, locationData.fiscal_day);
    weeks_list = weeks_list.filter(item => item[0] !== startStr);

    const shiftFormat = 'YYYY-MM-DD';
    var fileName = `schedule.csv`;
    if (rangeStart != null) {
      fileName = `${rangeStart.format(shiftFormat)}_${rangeEnd.format(shiftFormat)}`;
    }

    const draftShiftsToPublish = draftLogic.draftShiftsToPublish(shifts, shouldShowOpenShiftUI);
    const numberOfShiftsToPublish = draftShiftsToPublish.length;

    const publishText = (<FormattedMessage id="Scheduling.publish" defaultMessage='Publish ({num})' values={{ num: numberOfShiftsToPublish }} />);
    const nothingToPublishText = (<FormattedMessage id="Scheduling.publishZero" defaultMessage='Publish' />);

    const isProduction = (process.env.NODE_ENV === 'production' && window.location.hostname.includes('web.myshyft.com'));

    return (
      <div className='header-row-wrap'>

        <div className='flex-row'>
          {rangeStart && <WeekPickerComponent
            back={this.moveCurrentWeekBackward}
            forward={this.moveCurrentWeekForward}
            currentDateRangeStart={rangeStart}
            currentDateRangeEnd={rangeEnd}
            goToday={this.moveToToday}
          />}
          <SearchFilterComponent
            notifySearchTermChanged={notifySearchTermChanged}
            handleDepartmentSelect={handleDepartmentSelect}
            handleSkillSelect={handleSkillSelect}
            handleGroupSelect={handleGroupSelect}
            departments={departments}
            channels={channels}
            skills={skills}
            searchTerm={searchTerm}
            locationSettings={locationSettings} />
        </div>

          {rangeStart &&
            <div className='header-right-group'>
              <div className="dropdown">
                {/* TODO: re-enable when ready for release */}
                {false && <div className="generate-schedule-button">
                  <button
                    className="generate-main"
                    onClick={this.handleGenerateScheduleClick}
                  >
                    <FormattedMessage
                      id="Scheduling.generateSchedule"
                      defaultMessage="Generate Schedule"
                    />
                    <span className="beta-tag">BETA</span>
                  </button>
                  <button
                    className="generate-settings"
                    onClick={this.handleGenerationConfigClick}
                  >
                    <GearIcon />
                  </button>
                </div>}

                <button
                  className="header-button dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {copyToWeekText}
                </button>

                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                  {weeks_list.map((week) => (
                    <li className="dropdown-item" key={week[0]} onClick={(event) => this.handleCopyToWeekSelect.bind(this)(event, week[0])} >{week[1]}</li>
                  ))}
                </ul>

                { <button className="header-button dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"> {toolsText} </button> }
                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">

                  <li className='dropdown-item' key ={1001} >
                    <CSVLink data={tableFormatData} filename={fileName + "_importer.csv"} className=""
                        onClick={() => { Mixpanel.track('Export in Importer Format', {'target_week': rangeStart.format("MMM Do YYYY") + ' - ' + rangeEnd.format("MMM Do YYYY")}); }} >
                        {exportToPdfText}
                    </CSVLink>
                  </li>

                  <li className='dropdown-item' key ={1002} >
                    <CSVLink data={exportableData} filename={fileName + "_schedule.csv"} className=""
                        onClick={() => { Mixpanel.track('Export in Schedule Format', {'target_week': rangeStart.format("MMM Do YYYY") + ' - ' + rangeEnd.format("MMM Do YYYY")});
                        }} >
                        {exportToCSVText}
                    </CSVLink>
                  </li>

                  {/* Only show demo data menus if not production */}
                  {!isProduction && (
                    <>
                      <li className="dropdown-item" key={2001} onClick={this.handleCreateDemoData}>Create Demo Data</li>
                      <li
                        key={2002}
                        className="dropdown-item danger-action"
                        onClick={this.handleDeleteDemoData}
                      >
                        Delete Demo Data
                      </li>
                    </>
                  )}

                  <li className='dropdown-item danger-action' key ={1003} onClick={(event) => handleDeleteEntireScheduleModal()}> {deleteEntireScheduleText} </li>
                  <li className='dropdown-item danger-action' key ={1004} onClick={(event) => handleDeleteDraftsModal()}> {deleteUnpublishedChangesText} </li>
                </ul>

                { (numberOfShiftsToPublish > 0 && isPublishing == false) ?
                <button className='header-button publish-button' data-id="Deefeature2" onClick={this.handlePublishClick}> {publishText} </button>
                :
                <button className='header-button nothing-to-publish' data-id="Deefeature2"> {nothingToPublishText} </button>
                }

            </div>
          </div>}

        {showingPublishScheduleModal === true &&
          <Modal>
            <PublishScheduleComponent
              locationId={locationId}
              cancelModal={this.closePublishScheduleModel}
              draftShiftsToPublish={draftShiftsToPublish}
              publishDraftShiftsDispatch={publishDraftShiftsDispatch}
              currentDateRangeStart={rangeStart}
              currentDateRangeEnd={rangeEnd}
              shifts={shifts}
              allUsers={allUsers}
              allUnregisteredUsers={allUnregisteredUsers}
              message={message}
              notifyTeamOfPublishDispatch={notifyTeamOfPublishDispatch}
              scheduledResult={scheduledResult}
              openShiftResult={openShiftResult}
              vtoResult={vtoResult}
              scheduledUserCount={scheduledUserCount}
              shouldShowOpenShiftUI={shouldShowOpenShiftUI}
              shouldShowVTOUI={shouldShowVTOUI}
            />
          </Modal>
        }
        <styledConfirm.Overlay display={(showingPublishScheduleModal === true) ? 'block' : 'none'} />

        {showingContactSalesModal === true &&
          <Modal>
            <ContactSalesModal
              cancelModal={this.closeContactSalesModal}
            />
          </Modal>
        }
        <styledConfirm.Overlay display={(showingContactSalesModal === true) ? 'block' : 'none'} />

        {showCopyToWeekModal === true &&
          <Modal>
            <CopyToWeekComponent
              cancelModal={this.closeCopyToWeekModal.bind(this)}
              copyToWeekDispatch={this.copyToWeekDispatch.bind(this)}
              locationId={locationId}
              destWeekLabel={this.destWeekLabel}
              scrWeekDay={this.scrWeekDay}
              destWeekDay={this.destWeekDay}
              ownerIds={null}
              enableVto={shouldShowVTOUI}
            />
          </Modal>
        }
        <styledConfirm.Overlay display={showCopyToWeekModal === true ? 'block' : 'none'} />

        <BooModal show={showLoading} backdrop="static" keyboard={false} centered contentClassName="bg-transparent border-0" >
          <BooModal.Body>
            <div className="d-flex justify-content-center align-items-center">
              <Spinner animation="border" variant="primary" />
            </div>
          </BooModal.Body>
        </BooModal>

            {showGenerationConfigModal && (
              <Modal>
                <ScheduleGenerationConfigModal
                  cancelModal={this.closeGenerationConfigModal}
                />
              </Modal>
            )}
            {showConfirmModal && generationConfig && (
              <ScheduleGenerationConfirmModal
                config={generationConfig}
                onConfirm={this.handleConfirmGenerate}
                onCancel={this.handleCancelGenerate}
                error={this.state.error}
                isGenerating={isGenerating}
                userCount={allUsers ? allUsers.length : 0}
              />
            )}
            <styledConfirm.Overlay
              display={(showGenerationConfigModal || showConfirmModal) ? 'block' : 'none'}
            />

      </div>
    );
  }
}

ScheduleHeaderComponent.propTypes = {
};

export default injectIntl(ScheduleHeaderComponent);
